import { AuthError, AuthApiError } from "@supabase/supabase-js";

export const getErrorMessage = (error: AuthError) => {
  if (error instanceof AuthApiError) {
    switch (error.message) {
      case "Invalid login credentials":
        return "Credenciais inválidas";
      case "Email not confirmed":
        return "Email não confirmado";
      case "Invalid email or password":
        return "Email ou senha inválidos";
      case "User already registered":
        return "Usuário já registrado";
      case "Password should be at least 6 characters":
        return "A senha deve ter pelo menos 6 caracteres";
      default:
        console.error("Auth error details:", error);
        return error.message;
    }
  }
  console.error("Unexpected auth error:", error);
  return "Erro ao fazer login";
};